var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg_main"},[_c('v-row',{attrs:{"align":"stretch"}},[_c('v-col',{attrs:{"cols":"12"}},[(_vm.action === 'list')?_c('List'):_vm._e(),(_vm.action === 'create')?_c('Create'):_vm._e(),_c('v-container',[(_vm.action === 'edit')?_c('Edit'):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }